import moment from "moment";
class modelGroup {
  constructor(from, name, id, to, liqModel, liqModelId) {
    this.from = moment(from).utc().format("DD-MM-YYYY") 
    this.name = name;
    this.id = id;
    this.to =to== null ? " " : moment(to).utc().format("DD-MM-YYYY") 
    this.liqModel = liqModel;
    this.liqModelId = liqModelId;
  }
  static fromJson({ Desde, Grupo, GrupoId, Hasta, LiqModelo, LiqModeloId }) {
    return new modelGroup(Desde, Grupo, GrupoId, Hasta, LiqModelo, LiqModeloId);
  }
}
export default modelGroup;
